<!--
Author: TangChen
Date: 2019-01-03
Desc: 购买定投基金，由index.js 配置引入
-->
<template>
    <div class="comp-plan-buy comp">
        <el-form
            v-show="!buySuccess"
            ref="fundInfo"
            :model="fundInfo"
            :rules="rules"
            label-width="260px"
            class="pwdForm"
            inline-message
            v-on:submit.native.prevent
        >
            <el-form-item v-if="fund.combinationcode" label="组合代码：" class="form-text">
                <div v-cloak class="text-con">
                    {{ fund.combinationcode }}
                </div>
            </el-form-item>
            <el-form-item v-if="fund.comrate" label="基金代码：" class="form-text">
                <div v-cloak class="text-con">
                    {{ (fund.fundCode === "515981" ? "515980" : fund.fundCode) }}
                </div>
            </el-form-item>
            <el-form-item v-if="fund.comrate" label="基金名称：" class="form-text">
                <div v-cloak class="text-con">
                    {{ fund.fundName }}
                </div>
            </el-form-item>
            <el-form-item v-else label="基金名称：" class="form-text">
                <div v-cloak class="text-con">
                    {{ fund.fundname+'('+ (fund.fundcode === "515981" ? "515980" : fund.fundcode) +')' }}
                </div>
            </el-form-item>
            <el-form-item v-if="fund.comrate" label="投资比例：" class="form-text">
                <div v-cloak class="text-con">
                    {{ fund.comRate }}
                </div>
            </el-form-item>
            <el-form-item v-if="fund.payway" label="支付方式：" prop="way" class="form-text">
                <el-radio-group v-model="fundInfo.way" :disabled="action!=='0'">
                    <el-radio v-if="fund.payway.indexOf('1')>-1" label="1" name="sell">
                        现金宝<span>(可用余额：<span
                            class="red"
                        >{{ $util.fmtNum(xjbAll) }}</span>元)</span>
                    </el-radio>
                    <el-radio v-if="fund.payway.indexOf('2')>-1" label="2" name="sell">
                        银行卡
                    </el-radio>
                    <el-radio v-if="fund.payway.indexOf('3')>-1" label="3" name="sell">
                        汇款
                    </el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="支付渠道：" prop="pay" class="payway-list">
                <el-select
                    v-if="fundInfo.way!=='1' && bankLists.length > 0"
                    v-show="action==='0'"
                    v-model="fundInfo.pay"
                    placeholder="请选择支付方式"
                    :class="{'hasVal':bankInfo && bankInfo.label}"
                    :disabled="action!=='0'"
                    v-on:change="bankSel"
                >
                    <el-option-group
                        v-for="(group,index) in bankLists"
                        :key="index"
                        :label="group.label"
                        class="bank-sel"
                    >
                        <el-option
                            v-for="item in group.options"
                            :key="item.moneyaccount"
                            :label="item.label"
                            :value="item.moneyaccount"
                        >
                            <div v-if="!item.bankAdd" class="bank-info">
                                <img :src="$util.getImg(item.bankid)">
                                <span>{{ item.label }}</span>
                                <p v-if="!item.bankAdd">
                                    {{ item.text }}
                                </p>
                            </div>
                            <div v-if="item.bankAdd" class="option-group clear">
                                {{ item.bankCate }}<el-button
                                    type="blue"
                                    v-on:click.prevent="$router.push({name:'addbank'})"
                                >
                                    {{ item.bankAdd }}
                                </el-button>
                            </div>
                        </el-option>
                    </el-option-group>
                </el-select>
                <div v-if="fundInfo.way!=='1' && bankInfo && bankInfo.label" class="el-select-img">
                    <img :src="$util.getImg(bankInfo.bankid)">
                    <span class="k-text-flow">{{ bankInfo.label }}</span>
                </div>
                <el-radio-group v-if="(fundInfo.way==='1' && xjbInfo.length===0)||(fundInfo.way==='2' && bankLists.length === 0)" class="bank-radio">
                    <el-radio label="no-selec" border>
                        <div class="bank-img-sel">
                            <div v-if="fundInfo.way==='1'" class="k-text-flow">
                                您的现金宝还未充值，请立即<span
                                    class="like-a"
                                    v-on:click="$router.push({name:'currencycharge'})"
                                >前往充值</span>
                            </div>
                            <div v-else class="k-text-flow">
                                您的还未添加银行卡，请立即<span
                                    class="like-a"
                                    v-on:click="$router.push({name:'addbank',query:{biztype: 'plan'}})"
                                >前往添加</span>
                            </div>
                        </div>
                    </el-radio>
                </el-radio-group>
                <el-radio-group
                    v-if="fundInfo.way==='1' && xjbInfo.length>0"
                    v-model="fundInfo.pay"
                    class="bank-radio"
                    :disabled="action!=='0'"
                >
                    <el-radio
                        v-for="bank in xjbInfo"
                        :key="bank.transid+bank.xjbfundcode"
                        :label="bank.transid+bank.xjbfundcode"
                        border
                    >
                        <div class="bank-img-sel">
                            <img :src="$util.getImg(bank.bankid)">
                            <div class="k-text-flow">
                                <span class="bank-name" :title="$cache.getDict('150003',bank.bankid)">{{ $cache.getDict('150003',bank.bankid).toString().substr(0,6) }}</span>总额(元):<span
                                    class="bank-balance"
                                >{{ $util.fmtNum(bank.totalasset) }}</span>
                            </div>
                            <i class="el-icon-check" />
                        </div>
                    </el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item v-show="fund.sharetype === 'A,B'" label="收费方式：" prop="way" class="form-text">
                <el-radio-group v-model="fundInfo.sharetype">
                    <el-radio label="A" name="share">
                        前收费
                    </el-radio>
                    <el-radio label="B" name="share">
                        后收费
                    </el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="投资金额：" prop="amount">
                <el-input
                    v-model.trim="fundInfo.amount"
                    class="prefix"
                    :placeholder="pla"
                    :maxlength="14"
                    prefix-icon="fa fa-jpy"
                    :disabled="action==='2'"
                />
            </el-form-item>
            <!-- <el-form-item v-show="feeGate.charge" label="预估手续费：" class="form-text">
                <div class="text-con" v-html="feeH" />
            </el-form-item> -->
            <el-form-item label="计划名称：" prop="buyplanname" class="form-text">
                <el-input
                    v-model.trim="fundInfo.buyplanname"
                    placeholder="请输入投资计划名称"
                    :maxlength="32"
                    :disabled="action==='2'"
                />
            </el-form-item>
            <el-form-item label="扣款周期：" prop="debitcycle" class="form-text">
                <el-radio-group v-model="fundInfo.debitcycle" :disabled="action==='2'">
                    <el-radio
                        v-for="item in debitcycleArr"
                        :key="item.subitem"
                        :label="item.subitem"
                        name="debitcycle"
                    >
                        {{ item.subitemname }}
                    </el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="扣款日期：" prop="debitdate" :class="{'form-text':fund.sign&&!isPwdCheck&&!(wisdom&&action!=='0')}">
                <el-select v-model="fundInfo.debitdate" placeholder="请选择扣款日期" :disabled="action==='2'">
                    <el-option
                        v-for="item in debitdateArr"
                        :key="item.subitem"
                        :label="item.subitemname"
                        :value="item.subitem"
                    />
                </el-select>
            </el-form-item>
            <el-form-item v-show="fundInfo.debitcycle=='0'&&fundInfo.debitdate>=29" label="当月日期不足处理：" prop="nonexistdayflag" class="form-text">
                <el-radio-group v-model="fundInfo.nonexistdayflag" :disabled="action==='2'">
                    <el-radio
                        v-for="item in nonexistdayArr"
                        :key="item.subitem"
                        :label="item.subitem"
                        name="nonexistdayflag"
                    >
                        {{ item.subitemname }}
                    </el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item v-if="wisdom&&action!=='0'" label="参考指数：" prop="indextype">
                <el-select v-model="fundInfo.indextype" placeholder="请选择参考指数" :disabled="action==='2'">
                    <el-option
                        v-for="item in indexType"
                        :key="item.subitem"
                        :label="item.subitemname"
                        :value="item.subitem"
                    />
                </el-select>
            </el-form-item>
            <el-form-item v-if="wisdom&&action!=='0'" label="均线：" prop="policyvalue">
                <el-select v-model="fundInfo.policyvalue" placeholder="请选择均线" :disabled="action==='2'">
                    <el-option
                        v-for="item in subjectIndex"
                        :key="item.subitem"
                        :label="item.subitemname"
                        :value="item.subitem"
                    />
                </el-select>
            </el-form-item>
            <el-form-item v-if="wisdom&&action!=='0'" label="级差：" prop="investmove" :class="{'form-text':fund.sign&&!isPwdCheck}">
                <el-select v-model="fundInfo.investmove" placeholder="请选择级差" :disabled="action==='2'">
                    <el-option
                        v-for="item in investMove"
                        :key="item.subitem"
                        :label="item.subitemname"
                        :value="item.subitem"
                    />
                </el-select>
            </el-form-item>
            <el-form-item v-if="isPwdCheck" label="交易密码：" prop="pwd" :class="{'form-text':fund.sign}">
                <el-input
                    v-model.trim="fundInfo.pwd"
                    type="password"
                    placeholder="请输入交易密码"
                    :maxlength="16"
                />
                <span class="redemp-btn" v-on:click.prevent="$router.push({name: 'tradepwd'})"><span class="like-a">忘记密码？</span></span>
            </el-form-item>
            <el-form-item style="margin-left:-80px">
                <div class="check-box bar-pad showChenckbox" style="font-size: 14px; display: flex; align-items: flex-start;">
                    <div style="display: flex; align-items: flex-start;">
                        <input v-model="checkbox" type="checkbox" style="margin-top:9px" />
                        <span style="padding-left:5px;line-height:30px;width:623px">
                            本人已仔细阅读并同意
                           <span style="color:red;cursor: pointer;"  v-on:click="isShowAgreement = true">《定投协议》</span>{{ readFileInfoList.length?"、":"" }}
                            <span v-if="readFileInfoList.length!==0">
                                <span v-for="(item,index) in readFileInfoList" :key="index">
                                    <span v-if="$cache.getCompanyInfo().pdf_open_way === '0'">
                                        <a
                                            style="text-decoration:none; color: red"
                                            target="_blank"
                                            v-on:click="getClick(index)"
                                        >《{{ item.textname }}》</a>{{ index === readFileInfoList.length-1? "": index === readFileInfoList.length-2?"和" : "、" }}
                                    </span>
                                    <span v-else>
                                        <a
                                            :href="item.textaddress"
                                            style="text-decoration:none; color: red"
                                            target="_blank"
                                        >《{{ item.textname }}》</a>{{ index === readFileInfoList.length-1? "": index === readFileInfoList.length-2?"和" : "、" }}
                                    </span>
                                </span>
                            </span>
                            等法律文件，确认是本人自主决定购买，符合本人投资目标和风险承受能力。
                        </span>
                    </div>
                </div>
                <!-- <div
                    v-if="readFileInfoList.length!==0"
                    class="check-box bar-pad showChenckbox"
                    style="font-size: 14px; display: flex; align-items: flex-start;padding-left:-10px"
                >
                    <div style="display: flex; align-items: center;">
                        <input v-model="checkbox" type="checkbox" />
                        <span style="padding-left:5px;color:red;">我已阅读并同意: </span>
                    </div>
                    <ul>
                        <li v-for="(item,index) in readFileInfoList" :key="index">
                            <a
                                v-if="$cache.getCompanyInfo().pdf_open_way === '0'"
                                :href="$util.src('/common/download', { id: item.fileid,isopenfile:1 })"
                                style="text-decoration:none; color: red"
                                target="_blank"
                                v-on:click="getClick(index)"
                            >《{{ item.textname }}》</a>
                            <a v-else :href="item.textaddress" style="text-decoration:none; color: red" target="_blank">《{{ item.textname }}》</a>
                        </li>
                    </ul>
                </div> -->
                <div style="margin-right:380px;text-indent:1.3em;line-height:30px;">
                    定投须知：
                    <ul class="list-dot">
                        <li>请在扣款日前一天确保账户金额充足，如遇金额不足，我们会在下个交易日为您补扣一次</li>
                        <li>若约定扣款日为非基金开放日，则顺延到下一基金开放日进行扣款</li>
                        <li>如您指定的基金在实际扣款日暂停定期定额申购，则系统不进行自动扣款，且不进行顺延</li>
                    </ul>
                </div>
            </el-form-item>
            <el-form-item>
                <div style="width:50%;">
                    <div style="display:inline-block">
                        <el-button
                            type="primary"
                            class="medium"
                            :disabled="time>0 || checkBuy == false"
                            v-on:click="submitInfo('fundInfo')"
                            v-text="(action==='0'?'确认':(action==='1'?'修改':'启用'))+'定投'+countdown"
                        />
                        <span id="time"></span>
                    </div>
                    <el-button class="medium" style="margin-left:20px" v-on:click="$router.back()">
                        返回
                    </el-button>
                </div>
            </el-form-item>
        </el-form>
        <pdf-popup base64 :visible="pdfVisible" :need-time="needTime" :read-file-info-list="currentFileInfoList" v-on:close="finishReading"></pdf-popup>
        <fund-protocol v-if="!buySuccess" v-model="protocol" :fund="fund" v-on:all-read="generalBuy" />
        <result v-if="buySuccess" :active="2" :result="result" v-on:return-page="reset" v-on:return-login="$router.push({name:'myplan'})" />
        <agreement v-model="isShowAgreement" agrCon="agreement_generalbuy" title="定投协议" v-on:all-read="isShowAgreement=false"></agreement>
    </div>
</template>
<script>
import result from "@/components/layout/result";
import fundProtocol from "@/components/form/fundProtocol";
import cache from "@/assets/js/cache";
import PdfPopup from "@/components/util/pdfPopup";
import agreement from "@/components/form/agreement2.vue";

export default {
    name: "PlanBuy",
    components: {
        result,
        fundProtocol,
        PdfPopup,
        agreement
    },
    props: {
        generalFund: { // 基金信息基本数据
            required: true,
            type: Object
        },
        setFund: { // 智慧定投专属数据
            type: Object,
            default: function () {
                return {};
            }
        },
        wisdom: { // 是否是智慧定投
            type: Boolean,
            default: false
        },
        action: {// 定投操作类型，0签署定投协议，1修改定投协议，2启用定投协议
            type: String,
            default: "0"
        }
    },
    data () {
        return {
            // 表单信息
            fundInfo: {
                all: "0.00",
                amount: "",
                way: "",
                sharetype: "",
                buyplanname: "",
                debitcycle: "",
                debitdate: "",
                indextype: "0",
                policyvalue: "03",
                investmove: "10",
                pay: "",
                pwd: "",
                nonexistdayflag: ""
                // protocol: ""
            },
            feeGate: {},
            feeH: "", // 费率信息
            isPwdCheck: false, // 是否校验密码
            pla: "请输入起购金额",
            buySuccess: false, // 购买状态
            result: {// 结果页面信息
                cla: "register-success",
                msg: "您定投的申请已提交成功！",
                btnMsg: "预计下次扣款日期11月30日，如遇节假日则顺延，请耐心等待",
                special: false,
                btnL: {
                    text: "继续定投",
                    event: "return-page"
                },
                btnR: {
                    text: "我的定投",
                    event: "return-login"
                }
            },
            xjbAll: 0,
            time: 0, // 发送短信倒计时
            fund: {}, // 基金信息获取
            bankLists: [], // 银行卡列表
            limit: { text: "定投金额范围为：", min: "0", max: "0" }, // 限额
            rules: {// 校验规则配置
                amount: [
                    { validator: this.amountLimit, mes: "投资金额", trigger: "change" }
                ],
                pay: [
                    { required: true, message: "请选择支付方式", trigger: "change" }
                ],
                buyplanname: [
                    { validator: this.checkBuyPlanName, trigger: "blur" }
                ],
                debitcycle: [
                    { required: true, message: "请选择扣款周期", trigger: "change" }
                ],
                debitdate: [
                    { required: true, message: "请选择扣款日期", trigger: "change" }
                ],
                indextype: [
                    { required: true, message: "请选择参考指数", trigger: "change" }
                ],
                policyvalue: [
                    { required: true, message: "请选择均线", trigger: "change" }
                ],
                investmove: [
                    { required: true, message: "请选择极差", trigger: "change" }
                ],
                pwd: [
                    { required: true, message: "请输入交易密码", trigger: "blur" }
                ]
            },
            bankInfo: {}, // 校验银行卡信息
            xjbInfo: [],
            cfmdate: "", // 确认日期
            debitcycleArr: [],
            protocol: false,
            debitdateArr: [],
            indexType: [],
            subjectIndex: [],
            investMove: [],
            xjbSel: {}, // 当前选中现金宝信息
            firstinvestdate: "",
            bankId: "", // 已选中网点信息
            checkbox: false, //阅读确认1
            checkTime: true, //阅读确认2
            checkBuy: true,
            readFileInfoList: [],//披露文件信息
            readappno: "", //申请单编号
            countdown: "",
            interval: "",
            nonexistdayArr: [
                {
                    subitem: "0",
                    subitemname: "当月最后一日"
                },
                {
                    subitem: "1",
                    subitemname: "顺延到下月1号"
                }
            ],
            currentFileInfoList: [],//当前阅读信批文件
            pdfVisible: false,
            needTime: false,
            isShowAgreement: false,//固定阅读文件弹窗
        };
    },
    watch: {
        "fundInfo.amount" (val) {
            this.isAmount(val);
        },
        "fundInfo.way" (val) {
            this.fundInfo.pay = "";
            if (val === "1") {
                if (this.action !== "0") {
                    this.fundInfo.pay = this.bankId;
                    return;
                }
                this.fundInfo.pay = this.xjbInfo[0] ? (this.xjbInfo[0].transid + this.xjbInfo[0].xjbfundcode) : "";
            } else {
                this.getBank();
            }
        },
        "fundInfo.pay" (val) {
            if (this.fundInfo.way === "1") {
                const _x = this.xjbInfo.filter(item => {
                    return item.transid + item.xjbfundcode === val;
                })[0];
                if (_x) {
                    this.xjbSel = _x;
                    this.$set(this.limit, "min", this.fund.xjbmin);
                    this.$set(this.limit, "max", this.fund.xjbmax);
                } else {
                    this.$set(this.limit, "min", "0");
                    this.$set(this.limit, "max", "0");
                }
                this.pla = this.$util.fmtNum(this.limit.min) + "元起，最多可投" + this.$util.fmtNum(this.limit.max) + "元";
                this.queryRate();
            }
        },
        "fundInfo.debitcycle" (val) {
            if (val === "0") {
                this.debitdateArr = this.$cache.getDict("110207");
            } else if (val === "1") {
                this.debitdateArr = this.$cache.getDict("110213");
            } else if (val === "2") {
                this.debitdateArr = this.$cache.getDict("110214");
            }
            let _x = this.debitdateArr[0].subitem;
            if (this.action !== "0" && this.fund.investcycle === val) {
                _x = this.fund.investcyclevalue;
            }
            setTimeout(() => {
                this.$set(this.fundInfo, "debitdate", _x);
            }, 10);
        },
        "fundInfo.nonexistdayflag" (val){
            setTimeout(() => {
                this.$set(this.fundInfo, "nonexistdayflag", val);
            }, 10);
        },

        readFileInfoList: {
            handler: function (obj) {
                if (obj.every(function (item) {
                    return item.read;//产品概要强制阅读，其他不用
                })) {
                    this.checkbox = true;
                }
            },
            deep: true
        },
        checkbox(val) {
            if(this.readFileInfoList.length !== 0){
                if (val && !this.isReadFileReading && !this.readFileInfoList[0].read) {
                    this.currentFileInfoList = [this.readFileInfoList[0]];
                    this.needTime = true;
                    this.pdfVisible = true;
                }
                if (!val) {
                    this.readFileInfoList.forEach(item => item.read = false);
                }
            }
        },
        // 监听基金信息变化
        generalFund () {
            this.setFundInfo();
        },
        // 监听智慧定投信息变化
        setFund: {
            deep: true,
            handler (val) {
                if (this.wisdom && !this.fund.recommend) {
                    this.fund = Object.assign({}, this.fund, val);
                }
            }
        }
        // // 动态生成首次扣款日期，暂不使用
        // 'fundInfo.debitdate' (val) {
        //     this.getInvestDate()
        // }
    },
    mounted () {
        this.indexType = this.$cache.getDict("110033");
        this.subjectIndex = this.$cache.getDict("110211");
        this.investMove = this.$cache.getDict("110270");
        this.isPwdCheck = this.$cache.getPwdCheck(this.generalFund.way);
        this.debitcycleArr = this.$cache.getDict("110212");
        this.setFundInfo();
        this.getFileInfo();
    },
    methods: {
        //获取披露文件信息
        getFileInfo() {
            this.$util.queryReadFileInfo({
                "tano": this.fund.tano,
                "fundcode": this.fund.fundcode,
                "flag": "0"
            }, res => {
                res.forEach(item => {
                    item.read = false;
                    if(item.texttype.trim() === "1"){//产品概要
                        this.readFileInfoList.unshift(item);
                    }else{
                        this.readFileInfoList.push(item);
                    }
                });
            });
        },
        checkBuyPlanName(rule, value, callback) {
            if(value.trim() === "") {
                callback(new Error("请输入计划名称"));
                return;
            }
            this.$util.validateCCharacter(rule, value, callback);
        },
        //获取链接点击事件
        getClick(index){
            this.currentFileInfoList = [this.readFileInfoList[index]];
            this.readFileInfoList[index].read = true;
            if (this.currentFileInfoList[0].texttype === "1") {
                this.needTime = true;
            } else {
                this.needTime = false;
            }
            this.pdfVisible = true;
        },
        finishReading () {
            this.pdfVisible = false;
            if (this.currentFileInfoList[0].texttype === "1") {
                this.isReadFileReading = true;
            }
        },
        // 再次购买重置表单
        reset () {
            // 控制父组件是否显示基金列表
            if (this.wisdom) {
                this.$emit("back-fn", true);
            }
            this.buySuccess = false;
            this.bankInfo = {};
            this.$set(this.fundInfo, "way", "");
            this.$set(this.fundInfo, "amount", "");
            this.$set(this.fundInfo, "buyplanname", "");
            this.getBuyWay();
        },
        validateCCharacter(rule, value, callback){
            if(value !== ""){
                return this.$util.validateCCharacter(rule, value, callback);
            }else{
                callback();
            }
        },
        // 切换为银行卡支付时数据初始化
        getBank () {
            // 获取银行卡信息
            let _x = this.bankLists[0] ? this.bankLists[0].options[1].moneyaccount : "";
            if (this.action !== "0") {
                _x = this.bankId;
            }
            if (_x) {
                this.$set(this.fundInfo, "pay", _x);
                this.bankSel(_x);
            }
            this.$set(this.limit, "min", this.fund.min);
            this.$set(this.limit, "max", this.fund.max);
            this.pla = this.$util.fmtNum(this.fund.min) + "元起，最多可投" + this.$util.fmtNum(this.fund.max) + "元";
        },
        // 处理限额
        amountLimit (rule, value, callback) {
            this.$util.validateAmountLimit(this, rule, value, callback);
        },
        // 处理金额
        isAmount (val) {
            const _val = this.$util.checkAmount(val);
            clearTimeout(this.query);
            this.query = setTimeout(() => {
                this.$set(this.fundInfo, "amount", _val);
                this.queryRate();
            }, 1);
        },
        // 费率入参获取
        queryRate () {
            const _this = this;
            let _d = null;
            if (this.fundInfo.amount > 0 && this.fundInfo.sharetype === "A" && ((this.bankInfo.value && this.fundInfo.way !== "1") || (this.xjbSel.xjbfundcode && this.fundInfo.way === "1")) && this.fund.fundtype !== "2") {
                _d = {
                    fundcode: this.fundInfo.way === "1" ? this.xjbSel.xjbfundcode : this.fund.fundcode,
                    amount: this.fundInfo.amount,
                    channelid: this.fundInfo.way === "1" ? this.xjbSel.channelid : this.bankInfo.value,
                    bizcode: this.fundInfo.way === "1" ? "a" : "9",
                    targetfundcode: this.fundInfo.way === "1" ? this.fund.fundcode : ""
                };
                if (this.fund.comrate) {
                    _d.comratelist = this.fund.comrate;
                }
            }
            this.$util.getFee(_d, res => {
                _this.feeGate = res;
                _this.feeH = "<span class=\"red\">" + _this.$util.fmtNum(_this.feeGate.charge) + "元</span>(<s>" + _this.$util.fmtNum(_this.feeGate.originfee) + "</s>元，为您节省<span class=\"red\">" + _this.$util.fmtNum(_this.feeGate.discount) + "</span>元)";
            });
        },
        /* 提交表单数据，校验用户信息 */
        submitInfo (formName) {
            if (this.readFileInfoList.length !== 0) {
                if (!this.checkbox) {
                    return this.$alert("根据相关法规要求，请在交易前仔细阅读相关文件，并勾选“我已阅读并同意”选项。", "提示", {confirmButtonText: "确定"});
                }
            }
            //获取留痕申请编号
            this.$util.writeFileInfo({
                "readFileInfoList": this.readFileInfoList,
                "fundcode": this.fund.fundcode,
                "tano": this.fund.tano
            }, res => {
                this.readappno = res;
            });

            const _this = this;
            _this.$refs[formName].validate(valid => {
                if (valid) {
                    if (_this.action === "1") {
                        let _change = false;
                        try{
                            Object.keys(_this.fundInfo).forEach(key=>{
                                if( _this.fundInfo[key] !== _this.initVal[key] && key !== "pay"){
                                    if((key === "amount" && Number(_this.fundInfo[key]) !== Number(_this.initVal[key])) || key !== "amount"){
                                        _change = true;
                                        throw new Error("EndIterative");
                                    }

                                }
                            });
                        }catch(e){
                            if(e.message != "EndIterative") throw e;
                        }
                        if(!_change){
                            _this.$alert("您未修改任何定投信息，无需提交","信息未变动提示", "", {
                                confirmButtonText: "确定",
                                type: "warning",
                                callback: action => {

                                }
                            }).then(() => {
                                return false;
                            }).catch(() => {
                                return false;
                            });
                            return;
                        }
                    }
                    _this.$util.getSdxProtocol(_this.fund,(res)=>{
                        _this.fund = res;
                        _this.protocol = true;
                    });
                } else {
                    return false;
                }
            });
        },
        generalBuy(val){
            this.protocol = false;
            if(!val)return;
            const _this = this;
            if (_this.readFileInfoList.length > 0 && _this.readappno.length === 0) {
                return this.$alert("没有留痕申请编号,操作失败 请联系客服");
            }
            const _x = _this.getInvest();
            let _xjbSel = {};
            let _url = "";
            // 获取现金宝信息
            if (this.fundInfo.way === "1") {
                _xjbSel = this.xjbInfo.filter(item => {
                    return item.transid + item.xjbfundcode === _this.fundInfo.pay;
                })[0];
            }
            // 现金宝不存在，返回
            if (!_xjbSel) {
                return;
            }
            let data = {
                investperiods: _x.investperiods,
                investperiodsvalue: _x.investperiodsvalue,
                investcycle: _this.fundInfo.debitcycle,
                investcyclevalue: _x.investcyclevalue,
                riskwarnflag: _this.fund.riskwarnflag,
                riskmismatchflag: _this.fund.riskmismatchflag,
                highriskwarnflag: _this.fund.highriskwarnflag,
                fundmismatchflag: _this.fund.fundmismatchflag,
                channelid: _this.fundInfo.way === "2" ? _this.bankInfo.value : _xjbSel.channelid,
                tradepwd: _this.$util.enc(_this.fundInfo.pwd),
                planname: _this.fundInfo.buyplanname,
                firstinvestamount: _this.fundInfo.amount,
                firstsaledate: "",
                firstinvestdate: "",
                readappno: _this.readappno,
                nonexistdayflag: _this.fundInfo.nonexistdayflag
            };
            // 现金宝定投
            if (_this.fundInfo.way === "1") {
                _url = "trade/plan/xjb";
                data.branchcode = _xjbSel.branchcode;
                data.targetfundcode = _this.fund.fundcode;
                data.fundcode = _xjbSel.xjbfundcode;
                data.xjbfundcode = _xjbSel.xjbfundcode;
                data.sellvalue = _this.fundInfo.amount;
                data.moneyaccount = _xjbSel.moneyaccount;
                data.transid = _xjbSel.transid;
                data.targetsharetype = _this.fundInfo.sharetype;
                data.sharetype = _xjbSel.sharetype;
                data.tano = _xjbSel.tano;
            } else if (_this.fundInfo.way === "2") { // 银行卡定投
                _url = "trade/plan/normal";
                data.fundcode = _this.fund.fundcode;
                data.tano = _this.fund.tano;
                data.moneyaccount = _this.bankInfo.moneyaccount;
                data.sharetype = _this.fundInfo.sharetype;
            }
            // 智慧定投新增参数
            if (_this.wisdom) {
                _url = "trade/plan/" + (_this.fundInfo.way === "1" ? "aixjb" : "ai");
                data.indextype = _this.action === "0" ? _this.fund.indextype : _this.fundInfo.indextype;
                data.policyvalue = _this.action === "0" ? _this.fund.policyvalue : _this.fundInfo.policyvalue;
                data.investmove = ((_this.action === "0" ? _this.fund.investmove : _this.fundInfo.investmove) / 100).toString();
            }
            // 修改定投协议处理
            if (_this.action === "1") {
                _url = "trade/plan/" + (_this.fund.planpaytype === "2" ? (_this.wisdom ? "aixjb" : "xjb") : (_this.wisdom ? "ai" : "normal"));
                data.planno = _this.fund.planno;
                data.continueinvestamount = _this.fundInfo.amount;
            }
            // 启用定投协议处理
            if (_this.action === "2") {
                _url = "trade/plan/" + (_this.fund.planpaytype === "1" ? "normal" : "xjb") + "/resume";
                data.planno = _this.fund.planno;
            }
            // 组合定投开通
            if (_this.fund.comrate) {
                _url = "trade/plan/combine";
                data.saveplanflag = _this.fundInfo.way === "1" ? "b" : "a";
                data.combinationcode = _this.fund.combinationcode || "";
                data.comfundlist = _this.fund.fundcode;
                data.comratelist = _this.fund.comrate;
                data.comsharetypelist = _this.fund.sharetype;
                data.comtalist = _this.fund.tano;
                data.riskmatching = _this.fund.riskmismatchflag === "1" ? "0" : "1";
                if (_this.fundInfo.way !== "1") {
                    data.tano = "";
                }
            }
            // 下单
            _this.$util.request(_url, data, _this.action === "0" ? "POST" : "PUT").then(res => {
                if (!res.data) {
                    _this.resultMes(res);
                }
                // 获取下单时间
                _this.cfmdate = res.data ? (res.data[0].firstinvestdate || res.data[0].nextinvestdate || "") : "";
                _this.resultMes(res);
            });
        },
        // 初始化扣款周期和扣款日期值
        getInvest () {
            let _x = {
                investperiods: "",
                investperiodsvalue: "",
                investcyclevalue: ""
            };
            const selVal = this.fundInfo.debitdate;
            if (this.fundInfo.debitcycle === "0") {
                _x.investperiods = "0";
                _x.investperiodsvalue = "1";
                _x.investcyclevalue = selVal;
            } else if (this.fundInfo.debitcycle === "1") {
                _x.investperiods = "1";
                _x.investperiodsvalue = "1";
                _x.investcyclevalue = selVal;
            } else if (this.fundInfo.debitcycle === "2") {
                _x.investperiods = "1";
                _x.investperiodsvalue = "2";
                _x.investcyclevalue = selVal;
            } else {
                _x.investperiods = "";
                _x.investperiodsvalue = "";
                _x.investperiodsvaluedesc = "";
            }
            return _x;
        },
        // 获取第一次扣款日期，暂未使用
        getInvestDate () {
            const _x = this.getInvest();
            const _data = {
                fundcode: this.fund.fundcode,
                tano: this.fund.tano,
                investperiods: _x.investperiods,
                investperiodsvalue: _x.investperiodsvalue,
                investcycle: this.fundInfo.debitcycle,
                investcyclevalue: _x.investcyclevalue
            };
            this.$util.request("trade/plan/firstinvestdate", _data).then(res => {
                if (res.data) {
                    this.firstinvestdate = res.data[0].firstinvestdate;
                }
            });
        },
        // 获取对应银行卡信息
        bankSel (val) {
            const _this = this;
            for (const group of this.bankLists) {
                if (group.options && group.options.length > 0) {
                    for (const bank of group.options) {
                        if (bank.moneyaccount === val) {
                            _this.bankInfo = bank;
                            break;
                        }
                    }
                }
            }
            this.queryRate();
        },
        // 定投前信息查询
        getBuyWay () {
            const _this = this;
            // 初始化扣款周期
            let _debit = this.debitcycleArr[0].subitem;
            let _nonexistday = this.nonexistdayArr[0].subitem;
            if (this.action !== "0") {
                _debit = this.fund.investcycle;
                _nonexistday = this.fund.nonexistdayflag;
            }
            this.$set(this.fundInfo, "debitcycle", _debit);
            this.$set(this.fundInfo, "nonexistdayflag", _nonexistday);
            const _url = "trade/" + (this.fund.comrate ? "combine/buyinfo" : "plan/info");
            let _param = { fundcode: this.fund.fundcode };
            if (this.fund.comrate) {
                _param.combinationflag = this.fund.combinationflag ? this.fund.combinationflag : "";
                _param.combinationrate = this.fund.comrate;
            }
            this.$util.request(_url, _param).then(res => {
                if (res.data) {
                    _this.fund = Object.assign({}, _this.fund, res.data[0][0]);
                    _this.xjbInfo = res.data[1];
                    let _all = 0;
                    _this.xjbInfo.forEach(item => {
                        _all += Number(item.totalasset);
                    });
                    _this.xjbAll = _all;
                    let _way = _this.fund.payway.substr(0, 1);
                    if (_this.action !== "0") {
                        _way = _this.fund.planpaytype === "1" ? "2" : "1";
                        _this.beforePlan(res.data[2]);
                    }
                    _this.$set(_this.fundInfo, "way", _way);
                    _this.$set(_this.fundInfo, "sharetype", _this.fund.sharetype.substr(0, 1));
                    _this.bankLists = res.data[2].length > 0 ? _this.$util.getBankArr(res.data[2]) : [];
                    if(_this.action === "1"){
                        _this.initVal = Object.assign({},_this.fundInfo,{debitdate: _this.fund.investcyclevalue});
                    }
                }
            });
        },
        // 定投前信息获取
        beforePlan (data) {
            const _this = this;
            if (this.fund.planpaytype === "2") {
                data = this.xjbInfo;
            }
            const _bank = data.filter(item => {
                return item.channelid === _this.fund.channelid && item.paycenterid === _this.fund.paycenterid;
            })[0];
            if (_bank) {
                this.bankId = this.fund.planpaytype === "1" ? _bank.moneyaccount : _bank.transid + _bank.xjbfundcode;
            } else {
                _this.$alert("签署当前定投协议的网点已删除或失效，无法进行下一步操作，点击确认返回首页", "网点信息提示", {
                    confirmButtonText: "确定",
                    type: "warning",
                    callback: action => {
                        _this.$router.push("/home");
                    }
                }).then(() => {
                    return false;
                }).catch(() => {
                    return false;
                });
            }
            // 初始化存在定投协议数据
            this.$set(this.fundInfo, "amount", this.fund.firstinvestamount);
            this.$set(this.fundInfo, "buyplanname", this.fund.planname);
            if (this.wisdom) {
                this.$set(this.fundInfo, "indextype", this.fund.indextype);
                this.$set(this.fundInfo, "investmove", (this.fund.investmove * 100).toString());
                this.$set(this.fundInfo, "policyvalue", this.fund.policyvalue);
            }
        },
        // 生成确认信息
        resultMes (res) {
            if (res.data) {
                this.result.cla = "register-success";
                this.result.btnMsg = "预计" + (this.action === "1" ? "下一" : "首次") + "扣款日期为" + this.$util.fmtDate(this.cfmdate) + "， 如遇节假日则顺延，请耐心等待";
            } else {
                this.result.cla = "register-fail";
                this.result.btnMsg = "原因：" + res.msg;
            }
            if (this.action === "1"){
                this.result.msg = "您的" + (this.fundInfo.way === "1" ? "现金宝" : "") + "定投修改申请已受理" + (this.result.cla === "register-fail" ? "失败" : "成功");
            }else{
                this.result.msg = "您的" + (this.fundInfo.way === "1" ? "现金宝" : "") + "定投申请已受理" + (this.result.cla === "register-fail" ? "失败" : "成功");
            }

            // 控制父组件是否显示基金列表
            if (this.wisdom) {
                this.$emit("back-fn", false);
            }
            if (this.action !== "0") {
                this.result.btnL = {};
            }
            this.buySuccess = true;
        },
        setFundInfo () {
            this.fund = Object.assign({}, this.generalFund);
            // 组合购买基金数据初始化
            if (this.fund.comrate) {
                this.initComboData();
            }
            // 定投改变定投金额为空字符串
            this.fundInfo.amount = "";
            this.fundInfo.way = "";
            // 智慧定投不是推荐基金合并极差等值
            if (this.wisdom && !this.fund.recommend) {
                this.fund = Object.assign({}, this.fund, this.setFund);
            }
            this.getBuyWay();
        },
        // 初始化组合定投数据
        initComboData () {
            this.fund.fundCode = "[" + this.fund.fundcode.replace(/,/g, "] [") + "]";
            this.fund.fundName = "[" + this.fund.fundname.replace(/,/g, "] [") + "]";
            const _x = this.fund.comrate.split(",");
            let _y = "";
            for (let i in _x) {
                _y += "[" + _x[i] * 100 + "%] ";
            }
            this.fund.comRate = _y;
        },
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.comp-plan-buy {
    padding-bottom: 30px;

    .list-dot{
        li {
            position: relative;
            list-style: none;
            text-indent: 2.5em;
        }

        li::before {
            content: "\2022";
            position: absolute;
            left: -16px;
            display: inline-block;
            font-size: 26px;
        }
    }
}
</style>
